<mat-dialog-content class="lead-dialog-wrapper">
  <section>
    <h2 class="cmn-popup-title">Lead Details</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <div class="container">
      <div class="left-wrapper">
        <div class="lead-content" *ngIf="leadDetail">
          <div class="lead-content__left">
            <h4>Lead Name</h4>
            <h6>{{ leadDetail?.leadName }}</h6>
          </div>
          <div class="lead-content__right">
            <button [matMenuTriggerFor]="customerMenu" class="cmn-add-btn" *ngIf="leadDetail?.customerId === null">
              Create Customer
            </button>
            <mat-menu #customerMenu="matMenu">
              <button mat-menu-item (click)="handleNewCustomer()" >
                New Customer
              </button>
              <button mat-menu-item (click)="handleExistingCustomer($event)" >
                Existing Customer
              </button>
            </mat-menu>
            <div
              [ngClass]="{ show: isCustomerSelection }"
              class="common-dropdown filter-position activity"
              #dropdown
            >
              <button
                class="close-dropdown"
                (click)="handleExistingCustomer($event)"
              ></button>
              <label for="clientName">
                Customer Name <span class="red">*</span>
              </label>
              <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
                <mat-form-field>
                  <mat-select
                    placeholder="Search Customer"
                    formControlName="customerId"
                    required
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        [placeholderLabel]="'Search'"
                        [noEntriesFoundLabel]="'No options found'"
                        (input)="onSearch($event)"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let customer of customerData"
                      [value]="customer.id"
                    >
                      {{ customer.firstName + " " + customer.lastName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                  customerForm.get('customerId')!.touched &&
                  customerForm.get('customerId')!.hasError('required')
                "
                  >
                    Customer is required.
                  </mat-error>
                </mat-form-field>
                <button class="cmn-add-btn  submit-btn" type="submit">Save</button>
              </form>
            </div>
            <button class="cmn-add-btn" *ngIf="leadDetail?.customerId !== null && leadDetail?.status !== 'New' && leadDetail?.status !== 'ClosedLost'" (click)="createQuotation()">Create Quotation</button>
          </div>
        </div>
        <div class="statusUpdateWrapper" *ngIf="leadDetail">
          <form [formGroup]="statusUpdateForm" class="statusUpdateForm">
            <div>
              <h5>Status</h5>
              <div
                class="statusColor"
                [ngClass]="getStatusClass(leadDetail?.status)"
              >
                <h6>{{ getStatusLabel(leadDetail?.status) }}</h6>
              </div>
            </div>

            <div class="form-wrapper">
              <label for="">Change Status</label>
              <mat-form-field>
                <mat-select
                  placeholder="Select Status"
                  formControlName="status"
                >
                  <mat-option *ngFor="let key of leadStatusKeys" [value]="key"
                    >{{leadStatus[key]}}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="
            statusUpdateForm.get('status')!.invalid &&
            statusUpdateForm.get('status')!.touched
          "
                    class="error"
                    >Status is required.</mat-error
                  >
                </span>
              </div>
            </div>

            <div>
              <h5>Assigned To</h5>
              <div class="assignedTo">
                <h6>
                  {{ leadDetail?.assignedToData?.firstName || "--"}} {{
                  leadDetail?.assignedToData?.lastName || "--"}}
                </h6>
              </div>
            </div>
            <div class="form-wrapper" *ngIf="canAssigneeLeads$ | async">
              <label for="">Change Assignee</label>
              <mat-form-field>
                <mat-select
                  placeholder="Select Employee"
                  formControlName="assignedTo"
                >
                  <mat-option disabled>
                    <ngx-mat-select-search
                      [formControl]="employeeSearchControl"
                      [placeholderLabel]="'Search'"
                      [noEntriesFoundLabel]="'No options found'"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let employee of employeeData"
                    [value]="employee.id"
                    >{{employee.firstName}} {{employee.lastName}}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="
            statusUpdateForm.get('assignedTo')!.invalid &&
            statusUpdateForm.get('assignedTo')!.touched
          "
                    class="error"
                    >Assigned To is required.</mat-error
                  >
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="lead-details" *ngIf="leadDetail">
          <div class="details-box">
            <h4>Email</h4>
            <h6>{{ leadDetail?.email }}</h6>
          </div>
          <div class="details-box">
            <h4>Phone</h4>
            <h6>{{ leadDetail?.phone }}</h6>
          </div>
          <div class="details-box">
            <h4>Source</h4>
            <h6>{{ leadDetail?.source }}</h6>
          </div>

          <div class="details-box">
            <h4>Company Name</h4>
            <h6>{{ leadDetail?.companyName }}</h6>
          </div>
          <div class="details-box">
            <h4>Industry</h4>
            <h6>{{ leadDetail?.industry }}</h6>
          </div>
          <div class="details-box">
            <h4>Expected Value</h4>
            <h6>{{ leadDetail?.expectedValue }}</h6>
          </div>
          <div class="details-box">
            <h4>Expected Close Date</h4>
            <h6>{{leadDetail?.expectedCloseDate | date : 'dd MMM yyyy' }}</h6>
          </div>
          <div class="details-box">
            <h4>Probability</h4>
            <h6>{{ leadDetail?.probability }}</h6>
          </div>
          <div class="details-box">
            <h4>Notes</h4>
            <h6>{{ leadDetail?.notes }}</h6>
          </div>
        </div>
        <div class="activity-wrapper">
          <div class="activity-header">
            <h3>Activity</h3>
            <div
              [ngClass]="{ show: isDropdownOpen }"
              class="common-dropdown filter-position activity"
              #dropdown
            >
              <button
                class="close-dropdown"
                (click)="toggleDropdown($event)"
              ></button>
              <form [formGroup]="activityForm" (ngSubmit)="addActivity()">
                <h6 class="cmn-popup-heading">Add Activity</h6>
                <div class="filter-inner-content inner">
                  <div class="form-wrapper">
                    <mat-form-field>
                      <mat-label>Type</mat-label>
                      <mat-select
                        formControlName="type"
                        placeholder="Select Type"
                        required
                      >
                        <mat-option
                          *ngFor="let type of activityTypes"
                          [value]="type"
                        >
                          {{ type }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="activityForm.get('type')?.touched && activityForm.get('type')?.invalid"
                      >
                        Type is required.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>Details</mat-label>
                      <input
                        matInput
                        formControlName="details"
                        placeholder="What happened?"
                      />
                      <mat-error
                        *ngIf="activityForm.get('details')?.touched && activityForm.get('details')?.invalid"
                      >
                        Details are required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>Outcome</mat-label>
                      <input
                        matInput
                        formControlName="outcome"
                        placeholder="Outcome"
                      />
                      <mat-error
                        *ngIf="activityForm.get('outcome')?.touched && activityForm.get('outcome')?.invalid"
                      >
                        Outcome is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="btn-wrapper">
                    <button class="cmn-add-btn submit-btn" type="submit">
                      Save
                    </button>
                    <button
                      mat-button
                      type="button"
                      (click)="toggleDropdown($event)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <button
              class="cmn-add-btn add-activity-btn"
              (click)="toggleDropdown($event)"
              *ngIf="canActivityLeads$ | async"
            >
              + Add Activity
            </button>
          </div>
          <div class="activity-body">
            <table
              class="activity-table"
              *ngIf="activityData && activityData.length > 0"
            >
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Details</th>
                  <th>Outcome</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of activityData">
                  <td>{{ log.type }}</td>
                  <td>{{ log.details }}</td>
                  <td>{{ log.outcome }}</td>
                  <td>
                    {{ log.time ? (log.time | date:'MMMM d, h:mm a' : undefined
                    : undefined) : '' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="right-wrapper">
        <div class="notes-wrapper">
          <div class="notes-header">
            <h3>Notes</h3>
          </div>
          <div class="notes-body">
            <div class="notes-list">
              <ul>
                <li *ngFor="let notes of notesData">
                  <h4>admin: {{ notes?.content || "--" }}</h4>
                  <span>
                    {{ notes?.createdAt | date : "MMMM d 'at' h:mm a" }}</span
                  >
                </li>
              </ul>
            </div>
            <div class="add-notes-bar" *ngIf="canSendLeads$ | async">
              <form [formGroup]="notesForm">
                <div class="notes-input">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Write a comment..."
                      formControlName="content"
                    />
                  </mat-form-field>
                  <div class="custom-error">
                    <span>
                      <mat-error
                        *ngIf="
                    notesForm.get('content')!.invalid &&
                    notesForm.get('content')!.touched
                  "
                        class="error"
                        >Notes is required.</mat-error
                      >
                    </span>
                  </div>
                  <button
                    class="cmn-add-btn"
                    (click)="addNotes()"
                    type="submit"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</mat-dialog-content>
